/**
 * Teleport .custom-modal to <body> while open so it escapes sticky stacking contexts.
 * Works with AI "View Size in image" blocks (js-open-modal-* / modal-*).
 */
(function () {
  if (window.__pmclineCustomModalZFix) return;
  window.__pmclineCustomModalZFix = true;

  const markers = new WeakMap();

  function modalIdFromOpenClass(className) {
    const m = String(className || "").match(/js-open-modal-([\w-]+)/);
    return m ? "modal-" + m[1] : null;
  }

  function escalate(modal) {
    if (!modal || modal.dataset.pmclineEscalated === "1") return;
    const marker = document.createComment("pmcline-modal-home:" + (modal.id || ""));
    if (modal.parentNode) {
      modal.parentNode.insertBefore(marker, modal);
      markers.set(modal, marker);
      document.body.appendChild(modal);
      modal.dataset.pmclineEscalated = "1";
    }
    document.body.classList.add("pmcline-custom-modal-open");
  }

  function restore(modal) {
    if (!modal || modal.dataset.pmclineEscalated !== "1") return;
    const marker = markers.get(modal);
    if (marker && marker.parentNode) {
      marker.parentNode.insertBefore(modal, marker);
      marker.remove();
      markers.delete(modal);
    }
    delete modal.dataset.pmclineEscalated;
    const anyOpen = [...document.querySelectorAll(".custom-modal")].some(
      (el) => el.style.display === "block" || getComputedStyle(el).display === "block"
    );
    if (!anyOpen) document.body.classList.remove("pmcline-custom-modal-open");
  }

  function syncFromModal(modal) {
    if (!modal) return;
    const open = modal.style.display === "block" || getComputedStyle(modal).display === "block";
    if (open) escalate(modal);
    else restore(modal);
  }

  document.addEventListener(
    "click",
    (e) => {
      const openBtn = e.target.closest("[class*='js-open-modal-']");
      if (openBtn) {
        const id = modalIdFromOpenClass(openBtn.className);
        const modal = id ? document.getElementById(id) : null;
        requestAnimationFrame(() => syncFromModal(modal));
        setTimeout(() => syncFromModal(modal), 0);
        setTimeout(() => syncFromModal(modal), 50);
        return;
      }
      const closeBtn = e.target.closest("[class*='js-close-']");
      if (closeBtn) {
        const modal = closeBtn.closest(".custom-modal");
        requestAnimationFrame(() => {
          const stillOpen =
            modal &&
            (modal.style.display === "block" || getComputedStyle(modal).display === "block");
          if (!stillOpen) restore(modal);
          else syncFromModal(modal);
        });
        setTimeout(() => {
          document.querySelectorAll(".custom-modal").forEach(syncFromModal);
        }, 0);
      }
      // click on backdrop
      if (e.target.classList && e.target.classList.contains("custom-modal")) {
        setTimeout(() => syncFromModal(e.target), 0);
      }
    },
    true
  );

  // Escape key / programmatic close
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "attributes" && m.attributeName === "style") {
        syncFromModal(m.target);
      }
    }
  });
  function watchAll() {
    document.querySelectorAll(".custom-modal").forEach((modal) => {
      obs.observe(modal, { attributes: true, attributeFilter: ["style", "class"] });
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchAll);
  } else {
    watchAll();
  }
})();
